/**
 * 这里做应用级的全局重定向
 */

import { InquiryCreateType } from '../../shared/constants/inquiry';

const map = new Map<
  string,
  string | { url: string; query: Record<string, string | number | boolean> }
>();

// 默认首页
map.set('/', '/home');

// 活动
map.set('/activity/hivLecture', '/activity/hiv-lecture');
//健康日报页面
// 慢病服务首页 e-mall
map.set('/chronicDisease', '/home/user');
map.set('/chronic-disease-management/my-service-home', '/home/user');
// 慢病服务 med-ih-web
map.set('/chronic-disease-management/*', '/cdm/*');
// 自我管理
map.set('/self-manage/*', '/cdm/*');
map.set('/home/self', '/cdm/self-manage');
map.set(
  '/chronicDiseaseManagement/consoleHelper',
  '/chronic-disease-management/console-help'
);

map.set('/hospital', '/home/hospital');

map.set('/user', '/home/user');
/** 填表记录页 */
map.set('/user/formRecord', '/cdm/form-record/list');

map.set('/mall', '/home/mall');

// 商品详情
map.set('/mall/drugDetail', '/mall/drug-detail');
// 健康档案
map.set('/healthRecord', '/health-record');

// 用药建议
map.set('/prescription/medicationSuggest', '/prescription/suggest');

// 随诊填写处方信息
map.set('/consult/fill-patient', {
  url: '/inquiryInfoPerfect',
  query: { createType: InquiryCreateType.Consult },
});
// 开药门诊填写处方信息
map.set('/choose-patient', {
  url: '/inquiryInfoPerfect',
  query: { createType: InquiryCreateType.Inquiry },
});

export default Array.from(map);
